import { render, staticRenderFns } from "./UsersDetail.vue?vue&type=template&id=0911fef0&scoped=true&"
import script from "./UsersDetail.vue?vue&type=script&lang=js&"
export * from "./UsersDetail.vue?vue&type=script&lang=js&"
import style0 from "./UsersDetail.vue?vue&type=style&index=0&id=0911fef0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0911fef0",
  null
  
)

export default component.exports